import { useEffect, useState } from "react";
import axios from "axios";

const ChatbotQR = () => {
  const [qr, setQr] = useState("");
  const [loading, setLoading] = useState(false);
  const [estado, setEstado] = useState("");

  const API_URL = "http://localhost/TU_BACKEND"; // CAMBIAR

  const conectarWhatsapp = async () => {
    try {
      setLoading(true);
      setEstado("Creando instancia...");

      // Crear instancia
      await axios.post(`${API_URL}/CrearInstancia.php`, {
        cliente_id: 1,
      });

      setEstado("Obteniendo QR...");

      // Obtener QR
      const res = await axios.get(
        `${API_URL}/ObtenerQR.php?cliente_id=1`
      );

      // Evolution normalmente devuelve base64 dentro de:
      // res.data.base64
      // o res.data.qrcode.base64
      const qrBase64 =
        res.data.base64 ||
        res.data.qrcode?.base64 ||
        "";

      setQr(qrBase64);

      setEstado("Escaneá el QR con WhatsApp");
    } catch (error) {
      console.error(error);
      setEstado("Error al obtener QR");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    conectarWhatsapp();
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#111",
        color: "#fff",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <h1>Conectar WhatsApp</h1>

      <p>{estado}</p>

      {loading && !qr && <p>Cargando QR...</p>}

      {qr && (
        <div
          style={{
            background: "#fff",
            padding: "20px",
            borderRadius: "20px",
          }}
        >
          <img
            src={qr}
            alt="QR WhatsApp"
            width={300}
          />
        </div>
      )}

      <button
        onClick={conectarWhatsapp}
        style={{
          padding: "12px 20px",
          border: "none",
          borderRadius: "10px",
          cursor: "pointer",
          fontSize: "16px",
        }}
      >
        Generar nuevo QR
      </button>
    </div>
  );
};

export default ChatbotQR;